import React, { useMemo } from 'react';
import { Col, Row } from 'antd';
import { CommentInfoFragmentType } from '@common/graphql';

export const ShowComments = ({
  commentable,
  render,
  showMode = 'all',
  headerSlot,
  emptyRender,
}: {
  render: (comment: CommentInfoFragmentType) => React.ReactNode;
  showMode?: 'all' | 'first' | 'last';
  headerSlot?: React.ReactNode;
  emptyRender?: () => React.ReactNode;
  commentable: {
    id: string;
    comments?: CommentInfoFragmentType[] | null;
  };
}) => {
  const comments = commentable?.comments;

  const displayedComments = useMemo(() => {
    if (!comments?.length) {
      return [];
    }

    return {
      all: comments,
      first: [comments[0]],
      last: [comments[comments.length - 1]],
    }[showMode];
  }, [comments, showMode]);

  const hasComments = displayedComments.length > 0;

  return hasComments ? (
    <div className="ShowComments sentry-mask">
      {headerSlot}
      {displayedComments.map((comment) => (
        <Row key={comment.id}>
          <Col>{render(comment)}</Col>
        </Row>
      ))}
    </div>
  ) : (
    <>{emptyRender?.() ?? null}</>
  );
};
